import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@onward-delivery/design';

/**
 * Grey rows with a green dot and a title that expand to show details; several can be open at once.
 * @param {{ items: { key: string, title: React.ReactNode, content: React.ReactNode }[],
 *   emptyText: string }} props `emptyText` shows when there are no items
 */
const DetailAccordion = ({ items, emptyText }) =>
    items.length === 0 ? (
        <p className="text-sm text-muted">{emptyText}</p>
    ) : (
        <Accordion type="multiple" className="flex flex-col gap-2">
            {items.map((item) => (
                <AccordionItem key={item.key} value={item.key} className="rounded-md border-0 bg-[#efefef]">
                    {/* whitespace-normal: the trigger is a <button>, and a global
                        `button { white-space: nowrap }` (ShipperAccount/styles.css) would stop wrapping. */}
                    <AccordionTrigger className="gap-4 whitespace-normal px-4 text-left">
                        <span className="flex min-w-0 flex-1 items-center gap-6">
                            <span aria-hidden="true" className="h-3 w-3 shrink-0 rounded-full bg-primary" />
                            <span className="min-w-0 break-words text-sm font-normal text-foreground/80">
                                {item.title}
                            </span>
                        </span>
                    </AccordionTrigger>
                    <AccordionContent className="px-4 pb-4 pl-[3.25rem]">{item.content}</AccordionContent>
                </AccordionItem>
            ))}
        </Accordion>
    );

export default DetailAccordion;
